import * as tus from 'tus-js-client';

const tusUploadAsset = async (
    file: File,
    tusEndpoint: string,
    progressCallback: (uploadPercentage: number) => void,
    onSuccess: () => void,
    onError: (error: Error) => void,
) => {
    const upload = new tus.Upload(file, {
        endpoint: tusEndpoint,
        metadata: { fileName: file.name, filetype: file.type },
        uploadSize: file.size,

        onProgress: (bytesUploaded, bytesTotal) => {
            const uploadPercentage = (bytesUploaded / bytesTotal) * 100;
            progressCallback(uploadPercentage);
        },

        onSuccess,
        onError,
    });

    const previousUpload = await upload.findPreviousUploads().catch(console.error);

    if (previousUpload && previousUpload?.length) upload.resumeFromPreviousUpload(previousUpload[0]);
    else upload.start();

    return upload;
}

export default { tusUploadAsset };
